import React from "react"

const BigChip = ({
  text,
  bgcolor = '#5D5F70',
  x,
  y,
  width,
  height
}) => {
  return (
    <svg x={x} y={y} viewBox={"0 0 22 22"} width={width} height={height}>
      <circle cx={7} cy={7} r={7} fill={bgcolor} />
      <circle cx={15} cy={7} r={7} fill={bgcolor} />
      <rect x={7} y={0}
            width={8}
            height={14}
            fill={bgcolor}
      />
      <text x={11} y={8}
            fill={"white"}
            fontSize={'8px'}
            fontWeight={600}
            className={'text'}
            textAnchor="middle"
            alignmentBaseline="middle"
      >
        {text}
      </text>
    </svg>
  )
}

const LittleChip = ({
  text,
  bgcolor = '#5D5F70',
  x,
  y,
  width,
  height,
  pulse = false
}) => {
  return (
    <svg x={x} y={y} viewBox={"0 0 22 22"} width={width} height={height}>
      <circle cx={7} cy={7} r={7} fill={bgcolor} />
      <text x={7} y={8}
            fill={"white"}
            fontSize={'8px'}
            fontWeight={600}
            className={'text'}
            textAnchor="middle"
            alignmentBaseline="middle"
      >
        {text}
      </text>
    </svg>
  )
}

export default ({text, ...props}) => text < 100 ? <LittleChip text={text} {...props} /> : <BigChip text={text} {...props} />
